import React from "react";
import PendingIcon from "../../../../assets/assets/nip-pending.svg";

const Pending = () => {
  return (
    <div>
      <div className="nip-integration-header">Document Upload</div>

      <div className="doc-pending">
        <div className="middle-box">
          <div className="middle-box-image">
            <img src={PendingIcon} alt="pending icon" />
          </div>
          <div className="middle-box-title">Documents Approval Pending</div>
          <span className="middle-box-subtitle">
            Your documents have been sent for review. Kindly check <br /> back when admin
          approves
        </span>
        </div>
      </div>
    </div>
  );
};

export default Pending;
